// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3BHE_","text":"SelectPayment_text__19utA","title":"SelectPayment_title__36JF2","btn":"SelectPayment_btn__3ELLO"};